// Flagged articles tab for the Activity page.
// Each item is rendered as ArticleCard wrapped in a div that overlays a flag-reason badge.
// The badge is applied via wrapper div rather than an ArticleCard prop to keep ArticleCard
// unmodified for its other consumers. (ref: DL-009)
// Query fires only when this tab is active. (ref: DL-003)
import { useQuery, getActivityFlags } from "wasp/client/operations";
import ArticleCard from "../../articles/components/ArticleCard";
import { ArticleTabSkeleton } from "./ArticleTabSkeleton";
import { EmptyTabState } from "./EmptyTabState";
import { ErrorTabState } from "./ErrorTabState";
import { ARTICLE_CARD_GRID_CLASS } from "./articleGridClass";

interface FlagsTabProps {
  isActive: boolean;
}

export function FlagsTab({ isActive }: FlagsTabProps) {
  const { data, isLoading, error, refetch } = useQuery(
    getActivityFlags,
    undefined,
    { enabled: isActive },
  );

  if (isLoading) {
    return <ArticleTabSkeleton />;
  }

  if (error) {
    return <ErrorTabState onRetry={() => refetch()} />;
  }

  if (!data || data.length === 0) {
    return (
      <EmptyTabState message="Articles you flag for review will appear here." />
    );
  }

  return (
    <div className={ARTICLE_CARD_GRID_CLASS}>
      {data.map(({ article, reason }) => (
        // Wrapper div with badge keeps ArticleCard unmodified. (DL-009)
        <div key={article.id} className="relative">
          <div className="absolute top-2 left-2 z-10 flex items-center gap-1 px-2 py-0.5 rounded-full bg-warning/10 border border-warning/20 text-warning text-xs font-medium">
            <span>Flagged:</span>
            <span>{reason}</span>
          </div>
          <ArticleCard article={article} />
        </div>
      ))}
    </div>
  );
}
